//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import chroma from 'chroma-js'
import Map from './Map'
import {
  getDynamicMapCss,
  getCountryColorsMapCss,
  getBaseCss,
  getCombinedCssString
} from './dynamic-map-css'

export default {
  name: 'WorldMapVue',
  components: { Map },
  props: {
    countryData: {
      type: Object,
      required: true
    },
    showOverlay: {
      type: Boolean,
      default: false
    },
    countryColors: {
      type: Boolean,
      default: true
    },
    showColorBar: {
      type: Boolean,
      default: false
    },
    lowColor: {
      type: String,
      default: '#fde2e2'
    },
    highColor: {
      type: String,
      default: '#d83737'
    },
    defaultCountryFillColor: {
      type: String,
      default: '#dadada'
    },
    countryStrokeColor: {
      type: String,
      default: '#cccccc'
    }
  },
  data () {
    return {
      node: document.createElement('style'),
      chromaScale: chroma.scale([this.$props.lowColor, this.$props.highColor]),
      isMouseBottom: false
    }
  },
  watch: {
    countryData () {
      this.renderMapCSS()
    }
  },
  mounted () {
    document.body.appendChild(this.$data.node)
    this.renderMapCSS()
    if (!this.countryColors) {
      this.colorGradient()
    }
  },
  beforeDestroy () {
    this.$data.node.remove()
  },
  methods: {
    onMouseMove (ev, mapSvg) {
      const posY = ev.offsetY
      const mapHeight = mapSvg.getBoundingClientRect().height
      this.isMouseBottom = posY > (mapHeight / 2)
    },
    onMouseEnter (e) {
      this.$emit('mouseenter', e)
    },
    onMouseLeave (e) {
      this.$emit('mouseleave', e)
    },
    onClick (e) {
      this.$emit('click', e)
    },
    renderMapCSS () {
      const baseCss = getBaseCss(this.$props)
      const dynamicMapCss = this.countryColors ? getCountryColorsMapCss(this.$props.countryData) : getDynamicMapCss(this.$props.countryData, this.chromaScale)
      window.mapNode = this.$data.node
      this.$data.node.innerHTML = getCombinedCssString(baseCss, dynamicMapCss)
    },
    colorGradient () {
      const colorBar = document.getElementById('color_bar')
      const prefixes = ['', '-o-', '-ms-', '-moz-', '-webkit-']
      for (let x = 0; x < prefixes.length; x += 1) {
        colorBar.style.background = `${prefixes[x]}linear-gradient(to right, ${this.lowColor}, ${this.highColor})`
      }
    }
  }
}
